export default __webpack_public_path__ + "static/newia-tech-9ab047ce66e1c7d1bbfac20ea04c34e5.png";